"use client";

import "@/lib/css/rangeSlide.css";
import { useState, useEffect } from "react";
import { useDebouncedCallback } from "use-debounce";
import RangeSlider from "react-range-slider-input";
import { RangeSliderState } from "@/types/Product.type";
// import "react-range-slider-input/dist/style.css";
import Money from "@/components/ui/Money";

type Props = {
	initialMin: number;
	initialMax: number;
	min: number;
	max: number;
	step: number;
	onChange?: (data: RangeSliderState) => void;
	className?: string;
};

const RangeSliderCustom = ({
	initialMin,
	initialMax,
	min,
	max,
	step,
	onChange,
	className,
}: Props) => {
	const [minValue, setMinValue] = useState<number>(min);
	const [maxValue, setMaxValue] = useState<number>(max);

	const onChangeFilterRange = useDebouncedCallback(
		(minVal: number, maxVal: number) => {
			onChange?.({
				priceMax: maxVal,
				priceMin: minVal,
			});
		},
		600
	);

	useEffect(() => {
		setMinValue(min);
		setMaxValue(max);
	}, [min, max]);

	return (
		<div className={className}>
			<RangeSlider
				max={initialMax}
				min={initialMin}
				value={[minValue, maxValue]}
				// step={step}
				// thumbsDisabled={[false, ]}
				onInput={([min, max]: number[]) => {
					if (min >= 0 && max >= 0) {
						setMinValue(min);
						setMaxValue(max);
						onChangeFilterRange(min, max);
					}
				}}
			/>
			<div className="flex text-sm text-gray-500 mt-4">
				Từ <Money className="ml-1" value={minValue} /> -{" "}
				<Money value={maxValue} />
			</div>
		</div>
	);
};

export default RangeSliderCustom;
